<template>
	
<com-section v-on:back="$emit('back')" v-on:next="$emit('next')" :section="section" :hide-foot="!!subsection" :intro="(subsection === 'treatment') ? section.intro_medicine : section.intro" v-on:introducing="$emit('introducing')" v-on:introduced="$emit('introduced')">

	<slot></slot>
	
	<com-dashboard v-if="!subsection" :section="section" v-on:next="$emit('next')" v-on:click="onSegmentClick" />
	<com-diet v-if="subsection === 'diet'" :section="section" v-on:close="onCloseClick" />
	<com-stress v-if="subsection === 'stress'" :section="section" v-on:close="onCloseClick" />
	<com-treatment v-if="subsection === 'treatment'" :section="section" v-on:close="onCloseClick" v-on:next="$emit('next')" />
	<com-generic v-if="subsection === 'supplements'" :section="section" subsection="supplements" :segments="segments.supplements" v-on:close="onCloseClick" />
	<com-generic v-if="subsection === 'habits'" :section="section" subsection="habits" :segments="segments.habits" v-on:close="onCloseClick" />
	<com-generic v-if="subsection === 'activity'" :section="section" subsection="activity" :segments="segments.activity" v-on:close="onCloseClick" />

</com-section>

</template>

<script>

import comSection from '@/components/tool/common/Section'

import comDashboard from './improve/Dashboard'
import comDiet from './improve/Diet'
import comGeneric from './improve/Generic'
import comStress from './improve/Stress'
import comTreatment from './improve/Treatment'

export default {

	props: ['section'],

	components: {
		'com-section': comSection,
		'com-dashboard': comDashboard,
		'com-diet': comDiet,
		'com-generic': comGeneric,
		'com-stress': comStress,
		'com-treatment': comTreatment
	},

	data: function() {

		var isPatient = process.env.VUE_APP_MODE === 'patient'

		return {
			subsection: false,
			segments: {
				supplements: ['calcium', 'vitamins', 'sunlight'],
				habits: ['smoking', 'alcohol'],
				activity: isPatient ? ['steady', 'strong', 'straight'] : ['steady', 'strong', 'straight', 'falls', 'outdoors']
			}
		}

	},

	methods: {

		onSegmentClick: function(segment) {

			this.subsection = segment

		},

		onCloseClick: function() {

			this.subsection = false

		}

	}
	
}

</script>

<style scoped>

</style>